// CommentActions.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';
import { useUser } from 'context/UserContext';

// CSS
import './CommentActions.css';

// Icons
import Icon from 'svg/Icon';

/**
 * CommentActions
 *
 * Author-only delete control for a comment or reply.
 *
 * @returns {ReactNode}
 */
const CommentActions = ({
  comment,
  onDeleteClicked,
}) => {
  const { user } = useUser();
  const { theme } = useTheme();

  if (!user || !comment || comment.deleted) return null;
  if (comment.userKey !== user.key) return null;

  return (
    <div className="comment-actions">
      <button
        className="comment-actions-delete"
        type="button"
        title="Delete"
        aria-label="Delete"
        onClick={() => onDeleteClicked(comment)}
      >
        <Icon
          iconKey="delete"
          color={theme.foregroundMuted}
          width="15"
          height="15"
        />
      </button>
    </div>
  );
};

CommentActions.displayName = 'CommentActions';

export default CommentActions;
